import { Banner, Screenshot } from '@apis/index'
import Button from '@components/button'
import Fields from '@components/fields'
import DropDown from '@components/fields/dropdown'
import Grid from '@components/grid'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import useScrollToTop from '@hooks/useScrollToTop'
import { outlineButton } from '@pages/admin/payment/settings/form'
import { RootState } from '@store/index'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const ScreenshotForm = () => {
  const scrollToTop = useScrollToTop()

  const navigate = useNavigate()
  const { state } = useLocation()
  const [initialValues, setInitialValues] = useState({
    type: '',
    description: '',
    image: '',
    game: '',
  })

  useEffect(() => {
    if (!!state) {
      setInitialValues({
        type: state.type,
        description: state.description,
        image: state.image,
        game: state.game,
      })
    } else {
      setInitialValues({
        type: '',
        description: '',
        image: '',
        game: '',
      })
    }
  }, [state])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const payload: any = {
        type: values.type,
        description: values.description,
        gameType: values.game,
      }
      if (!state) {
        payload.images = [
          {
            base64: values.image.base64,
            extension: values.image.extension,
          },
        ]
      }
      if (!!state) {
        await Screenshot.update({
          state: 'screenshot',
          id: state.id,
          data: JSON.stringify(payload),
        })
      } else {
        await Screenshot.create({
          state: 'screenshot',
          data: JSON.stringify(payload),
        })
      }

      resetForm()
      navigate('/admin/banner-settings?tab=Screenshot References', {
        state: null,
      })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Fragment>
      <Wrapper>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ resetForm }) => (
            <Form>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '20px',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '98%',
                    minWidth: 0,
                  }}
                >
                  <DropDown
                    name="type"
                    label="Show When"
                    placeholder="Choose Option"
                    titleAsKey="title"
                    valueAsKey="key"
                    options={[
                      { title: 'Win', key: 'Win' },
                      { title: 'Loss', key: 'Lose' },
                    ]}
                    styleWrapper="z-index:9999999999999"
                  />
                </div>
                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '98%',
                    minWidth: 0,
                  }}
                >
                  <DropDown
                    name="game"
                    label="Game Type"
                    placeholder="Choose Option"
                    titleAsKey="title"
                    valueAsKey="key"
                    styleWrapper="z-index:999999999"
                    options={[
                      { title: 'Pubg', key: 'Pubg' },
                      { title: 'Free Fire', key: 'Free Fire' },
                    ]}
                  />
                </div>
                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.TextArea
                    name="description"
                    label="Description"
                    placeholder="Type here"
                  />
                </div>

                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.Upload name="image" variant="banner" />
                </div>
              </div>

              <Row
                styleRow={`
                  justify-content:flex-end;
                  margin-top:20px;
                  gap: 12px;
                  flex-wrap: wrap;
                `}
              >
                <Button
                  type="button"
                  title="Reset"
                  height={45}
                  width={100}
                  styleButton={outlineButton}
                  onClick={() => resetForm()}
                />
                <Button
                  title={!state ? 'Submit' : 'Update'}
                  height={45}
                  width={100}
                  type="submit"
                />
                {!!state && (
                  <Button
                    title={'Cancel'}
                    height={45}
                    width={100}
                    type="submit"
                    styleButton="background:red"
                    onClick={() => {
                      navigate(
                        '/admin/banner-settings?tab=Screenshot References',
                        { state: null },
                      )
                    }}
                  />
                )}
              </Row>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </Fragment>
  )
}

export default ScreenshotForm
